import { PriceChange } from './price-change';
import { Product } from './product';
import { ProductType } from './product-type';
import { Translation, TranslatedText } from './translated-text';

export class ProductGrouped extends Product {
  public grouped: any;

  constructor(
    id: string,
    sku: string,
    name: string,
    description: string,
    price: number,
    priceChanges: PriceChange[],
    order: any,
    energyInformation: string,
    imageUrl: string,
    isVisible = true,
    categoryId: string,
    isAvailable = true,
    originalImageUrl: string,
    grouped: any,
    posItemId: number,
    nameTranslations?: Translation[],
    serves?: string | TranslatedText,
  ) {
    super(
      id,
      sku,
      name,
      description,
      price,
      priceChanges,
      order,
      energyInformation,
      imageUrl,
      isVisible,
      categoryId,
      isAvailable,
      originalImageUrl,
      posItemId,
      nameTranslations,
      serves,
    );

    this.type = ProductType.GROUPED;

    this.grouped = grouped;
  }
}
